import { useState } from 'react';

import Breadcrumb from '@/components/atoms/breadcrumb/breadcrumb';
import HousingAllowanceForm from '@/components/molecules/housing-allowance-form/housingAllowanceForm';
import PaymentStepper from '@/components/molecules/payment-stepper/payment-stepper';

import StateOfHousingAllowanceResult from '../state-of-housing-allowance-result/stateOfHousingAllowanceResult';

import './stateOfHousingAllowance.scss';
import { StateOfHousingAllowanceResultAdapter } from './stateOfHousingAllowance.adapter';

const StateOfHousingAllowance = ({ contentInfo }: any) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [postulationInfoData, setPostulationInfoData] = useState<any>({});

  const getCurrentStep = () => {
    switch (currentStep) {
      case 0:
        return (
          <HousingAllowanceForm
            contentInfo={contentInfo}
            setCurrentStep={setCurrentStep}
            setPostulationInfoData={setPostulationInfoData}
          />
        );
      case 2:
        return (
          <StateOfHousingAllowanceResult
            contentInfo={contentInfo.referencias}
            states={StateOfHousingAllowanceResultAdapter(contentInfo)}
            postulationData={postulationInfoData}
            onClickBack={() => setCurrentStep(0)}
            buttonLoader={false}
          />
        );
      default:
        return <HousingAllowanceForm contentInfo={contentInfo} />;
    }
  };

  return (
    <div className="o-state-of-housing-allowance">
      <div className="o-state-of-housing-allowance__breadcrumb">
        <Breadcrumb
          content={
            contentInfo && contentInfo.migaDePan
              ? contentInfo.migaDePan
              : 'Inicio/Pagos/Pago de crédito'
          }
        />
      </div>
      <PaymentStepper
        itemList={contentInfo.lista}
        currentIndex={currentStep}
        title={contentInfo.nombre}
        subtitle={contentInfo.subtitulo}
        titleType="h1"
      />
      {getCurrentStep()}
    </div>
  );
};

export default StateOfHousingAllowance;
